var map = {
	"./en/form/components.lang.json": "x5va",
	"./en/form/form.lang.json": "oRWO",
	"./en/home/home.lang.json": "xxLi",
	"./en/home/welcome.lang.json": "2NTM",
	"./en/user/user.lang.json": "tCHQ",
	"./fr/form/components.lang.json": "jqqn",
	"./fr/form/form.lang.json": "p0E1",
	"./fr/home/home.lang.json": "w4NR",
	"./fr/home/welcome.lang.json": "L0mf",
	"./fr/user/user.lang.json": "WM8q"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PG1Q";


//////////////////
// WEBPACK FOOTER
// ./src/lang/default ^\.\/.*\.lang\.json$
// module id = PG1Q
// module chunks = 1